import { object } from 'prop-types';
import { useTheme } from '@wegroup/design-system';

const IllustrationCouple = () => {
  const { colors } = useTheme();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="112"
      height="70"
      fill="none"
      viewBox="0 0 112 70"
    >
      <path
        fill={colors.primary[50]}
        d="M64.7.307H44.64c-12.837 0-23.243 10.377-23.243 23.179v22.641c0 12.802 10.406 23.18 23.243 23.18H64.7c12.836 0 23.242-10.378 23.242-23.18V23.486C87.942 10.684 77.536.306 64.7.306z"
      ></path>
      <path
        stroke={colors.primary[100]}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M1.581 59.883h109.321"
      ></path>
      <path
        fill={colors.primary[700]}
        d="M44.182 58.94h2.451V26.198l-3.075-4.468h-1.081c-3.075 0-3.892 2.242-3.916 3.363v14.582c0 2.287 1.97 3.099 2.955 3.219.44 4.756 1.345 14.422 1.441 15.037.144.769.529 1.01 1.225 1.01z"
      ></path>
      <path
        fill={colors.primary[700]}
        d="M49.05 58.94h-2.451V26.198l3.075-4.468h1.08c3.075 0 3.892 2.242 3.916 3.363v14.582c0 2.287-1.97 3.099-2.955 3.219-.44 4.756-1.345 14.422-1.44 15.037-.145.769-.53 1.01-1.226 1.01z"
      ></path>
      <circle
        cx="46.616"
        cy="15.682"
        r="4.997"
        fill={colors.primary[700]}
      ></circle>
      <path
        fill={colors.primary[600]}
        d="M59.483 59.098h1.537c-.056-11.57-.168-34.88-.168-35.552-.384 0-2.594-.312-4.276-1.225-1.345-.73-2.146.192-2.378.744-1.538 3.756-4.675 11.392-4.925 11.891-.312.625-.504 1.514.77 2.282 1.018.615 1.96-.336 2.305-.889l3.94-9.296c.128 1.393.442 4.511.672 5.837.231 1.326-.016 2.667-.168 3.171-.969 2.995-2.983 9.19-3.29 10.017-.308.827.255.985.576.961h1.61c.96 0 1.248.545 1.272.817.505 3.13 1.552 9.58 1.706 10.33.154.749.609.92.817.912z"
      ></path>
      <path
        fill={colors.primary[600]}
        d="M62.158 59.098h-1.537c.056-11.57.168-34.88.168-35.552.384 0 2.594-.312 4.276-1.225 1.345-.73 2.146.192 2.378.744 1.538 3.756 4.675 11.392 4.925 11.891.312.625.504 1.514-.77 2.282-1.018.615-1.96-.336-2.305-.889l-3.94-9.296c-.128 1.393-.442 4.511-.672 5.837-.23 1.326.016 2.667.168 3.171.969 2.995 2.983 9.19 3.29 10.017.308.827-.255.985-.576.961h-1.61c-.96 0-1.248.545-1.272.817-.505 3.13-1.552 9.58-1.706 10.33-.154.749-.608.92-.817.912z"
      ></path>
      <circle
        cx="60.821"
        cy="15.835"
        r="4.997"
        fill={colors.primary[600]}
      ></circle>
      <circle
        cx="71.599"
        cy="13.339"
        r="2.5"
        fill={colors.primary[500]}
      ></circle>
      <circle
        cx="36.507"
        cy="11.839"
        r="1.5"
        fill={colors.primary[500]}
      ></circle>
      <circle cx="80.241" cy="51.609" r="1" fill={colors.primary[500]}></circle>
      <rect
        width="2"
        height="8"
        x="29.176"
        y="34.803"
        fill={colors.primary[500]}
        rx="1"
        transform="rotate(45 29.176 34.803)"
      ></rect>
      <rect
        width="2"
        height="8"
        x="23.519"
        y="36.217"
        fill={colors.primary[500]}
        rx="1"
        transform="rotate(-45 23.52 36.217)"
      ></rect>
      <rect
        width="1.5"
        height="6"
        x="78.491"
        y="22.052"
        fill={colors.primary[500]}
        rx="0.75"
      ></rect>
      <rect
        width="1.5"
        height="6"
        x="76.241"
        y="25.802"
        fill={colors.primary[500]}
        rx="0.75"
        transform="rotate(-90 76.241 25.802)"
      ></rect>
    </svg>
  );
};

IllustrationCouple.propTypes = {
  theme: object,
};

export default IllustrationCouple;
